import { ThumbnailImageProps } from 'react-grid-gallery';
import styles from './attachedImage.module.css';

export const AttachedImage = (props: ThumbnailImageProps) => {
  const { src, alt, style } = props.imageProps;
  return <img alt={alt} className={styles.attachedImage} src={src} style={style} />;
};
